import { IEvent, IHost } from "@Interfaces";
import {
    calculatePaymentInfoForSingleOffering,
    IPaymentInfoForSingleOffering,
} from "@Utils";

/**
 * If this flag is true, the payment flow will assume that stripe is being used for an international creator
 */
export const getHasToCollectFullAddressForStripe = ({
    hostData,
    eventData,
    event,
}: {
    hostData: IHost.IHostData;
    eventData: IEvent.IEventData;
    event: IEvent.IStore;
}) => {
    const {
        paymentInfo: {
            slots,
            quantity,
            numberOfCustomers, // Listings selected for upsell
        },
        discount: { discountData },
    }: IEvent.IStore = event;

    const computedPaymentValues: IPaymentInfoForSingleOffering.IReturn =
        calculatePaymentInfoForSingleOffering({
            eventData,
            quantity,
            slots,
            numberOfCustomers,
            discountData,
        });

    const {
        priceValues: {
            totalPrice, // Final price, to be paid
        },
    } = computedPaymentValues;

    return !!(
        (
            (hostData?.is_international_creator ||
                eventData?.is_full_address) &&
            totalPrice > 0
        ) // No point collecting full address if the payment is free and won't invoke the Stripe gateway
    );
};
